module.exports = require('../_components/@alicd/next-dom/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/dom/index.js
// module id = 661
// module chunks = 0